import React, {Fragment} from "react";
import {Link} from "react-router";

import Panel from "./Panel";
import Right from "./Right";
import FormItem from "./FormItem";

import langs from "./langs/appIndex";
import phpLangs from "./langs/phpIndex";

import {api} from "./baseFunctions";


export default class GroupsPage extends React.Component {

    state = {
        data: {
            "da-DK": [],
        },
        firms: [],
        newData: [],
        editing: false,
    };


    componentDidMount(){
        this.getData();
    }

    getData = () => {

        api("POST", {"type": "getFirms"}, (d) => {
            if(!d.error)
            {
                this.setState({
                    firms: d.data
                });
            }
        }, this.props.auth);

        api("POST", {type: "getLocales"}, (data) => {
            console.log("Got locale", data);
            if(!data.error)
            {
                let newData = {};
                let keys = Object.keys(data.data);
                for(let i = 0; i < keys.length; i++)
                {
                    const key = keys[i];
                    for(let j = 0; j < data.data[key].length; j++)
                    {
                        const curr = data.data[key][j];
                        if(!newData[curr.key])
                        {
                            newData[curr.key] = [];
                        }
                        newData[curr.key].push(curr);
                    }
                }

                
                this.setState({
                    data: data.data,
                    newData,
                });

            }
        }, this.props.auth);
    }

    updateRow(index, key, val, firmID)
    {
        const newData = {...this.state.data};
        newData[index][key].value = val;
        newData[index][key].firmID = firmID;

        this.setState({
            data: newData
        });
    }

    save()
    {
        let data = [];
        let keys = Object.keys(this.state.data);
        for(let i = 0; i < keys.length; i++)
        {
            data = [
                ...data,
                ...this.state.data[keys[i]],
            ];
        }

        api("POST", {type: "saveLocales", data}, (d) => {
            if(d && !d.error)
            {
                alert("Oversættelserne er gemt!");
                this.getData();
            }
        }, this.props.auth);
    }


    render(){
        const LANG = phpLangs[this.props.lang];
        const APP_LANG = langs[this.props.lang];
        const editing = this.state.editing;
        //console.log("Editing", Object.keys(this.state.newData));
        const langData = this.state.data['da-DK'];
        const dataLangs = Object.keys(this.state.data);
        return (<Right title="Oversættelser" token={this.props.auth} lang={this.props.lang}>
          
            <Panel title="Oversigt">

                <table className="table table-striped jambo_table bulk_action" id="ras" style={this.state.data.length === 0 ? {display: "none"} : {}}>
                    <thead>
                        <tr className="headings">
                            <th className="column-title">Unik nøgle</th>
                            {
                                Object.keys(this.state.data).map(d => <th className="column-title">{d}</th>)
                            }
                            <th className="column-title">Firma</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            langData.sort((a, b) => b.firmID - a.firmID).map((key, i) => {
                                const data = dataLangs.map(lang => this.state.data[lang].find(d => d.key === key.key && d.firmID === key.firmID));
                                return (<tr key={key.id}>
                                    <td className="column-title">
                                        <input defaultValue={key.key} disabled={true} />
                                    </td>
                                    {
                                        data.map(locale => {
                                            const checkI = this.state.data[locale.lang] ? this.state.data[locale.lang].findIndex(d => d.id === locale.id) : -1;
                                            return <td className="column-title">
                                                <input defaultValue={locale.value} onBlur={(e) => this.updateRow(locale.lang, checkI, e.target.value, key.firmID)}/> 
                                            </td>;
                                        })
                                    }
                                    <td className="column-title">
                                        <select defaultValue={key.firmID} onChange={(e) => {
                                            data.forEach(locale => {
                                                const checkI = this.state.data[locale.lang] ? this.state.data[locale.lang].findIndex(d => d.id === locale.id) : -1;
                                                this.updateRow(locale.lang, checkI, locale.value, e.target.value === "-1" ? null : Number(e.target.value));
                                            });
                                        }}>
                                            <option value="-1">Global</option>
                                            {
                                                this.state.firms.map(firm => <option value={firm.id} key={firm.id}>{firm.name}</option>)
                                            }
                                        </select>
                                    </td>   
                                </tr>);
                            })
                        }
                    </tbody>
                </table>
                <button onClick={() => {
                    const key = window.prompt("Nøgle:");
                    if(key)
                    {
                        const newData = {...this.state.data};
                        Object.keys(newData).forEach(lang => {
                            newData[lang].push({
                                firmID: null,
                                key,
                                lang,
                                value: '',
                            });
                        });
                        this.setState({data: newData});
                        // if(newData[key])
                        // {
                        //     alert("Nøglen eksistere allerede");
                        // }else{
                        //     newData[key] = [];
                        //     this.setState({newData});
                        // }
                    }
                }} style={{width: "100px"}}>+</button>
                <button onClick={() => this.save()}>Gem</button>
        </Panel>

        </Right>);
    }
}


// WEBPACK FOOTER //
// ./src/components/LocalePage.js